<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { showToast } from '../lib/toast';
    import EmailInput from './EmailInput.svelte';
    import { sendEmailMagicLink } from '../lib/apiService';
    import { onMount } from 'svelte';

    export let returnTo = '/game-assist/';

    // Form state
    let email = '';
    let isLoading = false;
    let emailSent = false;

    // Check if return_to is in query params
    onMount(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const queryReturnTo = urlParams.get('return_to');

        if (queryReturnTo) {
            // Ensure it's a relative path by removing any protocol and domain
            returnTo = queryReturnTo.replace(/^(?:https?:)?(?:\/\/[^\/]+)?(\/.*)?$/, '$1');
        }

        // Load saved email from localStorage
        const savedEmail = localStorage.getItem('pankla_login_email');
        if (savedEmail) {
            email = savedEmail;
        }
    });

    // Validate email format
    function isValidEmail(value: string): boolean {
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailPattern.test(value);
    }

    // Send login magic link
    async function handleSendMagicLink() {
        if (!email.trim() || !isValidEmail(email)) {
            showToast($_('login.invalid_email'), 'error');
            return;
        }

        isLoading = true;

        // Save email to localStorage
        localStorage.setItem('pankla_login_email', email);

        try {
            await sendEmailMagicLink(email, returnTo, (result, status) => {
                isLoading = false;

                if (status === 200) {
                    emailSent = true;
                } else {
                    showToast($_('login.send_error'), 'error');
                }
            });
        } catch (error) {
            isLoading = false;
            showToast($_('login.send_error'), 'error');
        }
    }
</script>

<div class="container">
    <h1 class="brand-font my-6">{$_('login.title')}</h1>

    {#if emailSent}
        <div class="card mt-6 mb-6">
            <h3>{$_('login.check_email_title')}</h3>
            <p>{$_('login.check_email_description', { values: { email: email } })}</p>
            <p class="text-muted text-sm mt-4">{$_('login.check_spam')}</p>

            <button
                type="button"
                class="secondary mt-6"
                on:click={() => { emailSent = false; }}
            >
                {$_('login.try_again')}
            </button>
        </div>
    {:else}
        <div class="login-form">
            <p class="text-lg mb-4">{$_('login.email_instruction')}</p>

            <form on:submit|preventDefault={handleSendMagicLink}>
                <EmailInput
                    bind:email
                    label={$_('login.email_label')}
                    placeholder={$_('login.email_placeholder')}
                    required={true}
                    disabled={isLoading}
                />
                <p class="text text-sm text-italic text-muted">
                    {$_('login.no_email')}
                    <a href="/account/#/login-phone" class="text-primary">{$_('login.use_phone')}</a>
                </p>


                <button
                    type="submit"
                    class="primary mt-4"
                    disabled={isLoading || !email || !isValidEmail(email)}
                    aria-busy={isLoading}
                >
                    {isLoading ? $_('login.sending') : $_('login.send_magic_link')}
                </button>
            </form>

            <p class="text text-xs mt-4 text-center">
                {$_('login.noAccount')}
                <a href="/account/#/signup" class="text-primary">{$_('login.signup')}</a>
            </p>

            <hr class="my-6">


        </div>
    {/if}
</div>

<style>
    .login-form {
        max-width: 400px;
    }
</style>
